<div id="offlineNoInternetConnectionContainer">
  <div class="logos-container">
    <div id="snaponLogoContainer" class="logo-container">
      <div id="snaponLogo" class="crm-industrial-font icon-snapon-logo"></div>
    </div>
    <div id="impactLogoContainer" class="logo-container">
      <div id="impactLogo" class="impact-logo">
        <app-icon id="impact-logo" [icon]="appIcon"></app-icon>
      </div>
    </div>
  </div>

  <div id="checkConnectivityMessageContainer" class="text-container">
    <app-icon id="offline-logo" class="offline-logo" [icon]="offlineIcon"></app-icon>
    <p id="internetConnectionNeededMessage">{{appStrings.goOffline_internetConnectionNeeded}}</p>
    <p id="checkConnectivityMessage">{{appStrings.goOffline_checkConnectivity}}</p>
  </div>

  <div class="button-container">
    <button id="retryButton" class="button primary" mat-button (click)="retry()">
      <span class="crm-industrial-font icon-refresh"></span>
      {{appStrings.button_retry}}
    </button>
  </div>
</div>
